import {FC} from 'react'
import { getStyledDealsWrapper } from '../../styled-components/DealsSection.styled'
import { Fire } from '../icons/Fire.component'
import { DealsCard } from './DealsCard.component'

export interface DealsSectionProps {
    
}

export const DealsSection: FC<DealsSectionProps> = (props) => {

    const DealsWrapper = getStyledDealsWrapper()

    return(
        <DealsWrapper>
            <div>
                <span className='title'>Hot <Fire height={60} width={70} /> <br /> deals for you</span>
                <div className='description'>Online shopping for retail sales. <br />  direct to consumers.</div>
            </div>
            <DealsCard title='1.5% cashback'/>
            <DealsCard title='30-day terms'/>
            <DealsCard title='Save money'/>
        </DealsWrapper>        
    )
}